import * as types from '../actions/types';

const initialState = {
    page:1,
    success:false
}

export default function NotifypageReducer(state = initialState, action = undefined) {
    switch (action.type) {
            case types.PAGE_NOTIFICATION:
                return{
                    page: action.payload,
                    success:true
                }
        default:
            return state
    }
}
